import styled from "styled-components";

import { LayoutStackOrder } from "../../global.style";

export const ProgressBannerWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 137px;
    z-index: ${LayoutStackOrder.Menu + 1};
`;